import { useMemo, useCallback, useContext } from 'react';
import { UserContext } from '../../../../../providers/UserContext';
import { homePageConfig } from '#types';

export const useHomeFormVersionsBaseFilters = (baseView: string) => {
  const { user } = useContext(UserContext);

  const resolveReportInitialFilters = useCallback((reportId: string) => {
    const baseViewConfig = homePageConfig.formsTable.reports.find(v => v.id === reportId);
    if (!baseViewConfig?.initialFilters) {
      return [];
    }

    return baseViewConfig.initialFilters.flatMap((filter) => {
      const resolvedValues = filter.value
        .map((value) => {
          if (typeof value === 'string') return value;
          if (value && typeof value === 'object' && 'type' in value) {
            const token = value as { type?: unknown };
            if (token.type === 'currentUserId') {
              return user?.uid ?? '';
            }
          }
          return '';
        })
        .filter((v) => v !== '');

      if (resolvedValues.length === 0) {
        return [];
      }

      return [{
        id: filter.id,
        value: resolvedValues,
      }];
    });
  }, [user?.uid]);

  const initialFilters = useMemo(() => {
    return resolveReportInitialFilters(baseView);
  }, [baseView, resolveReportInitialFilters]);

  return {
    initialFilters,
    resolveReportInitialFilters,
  };
};


